import React from 'react';

import noop from 'lodash/noop';

import Box from '@mui/material/Box';


const Form = React.forwardRef(({ children, onSubmit = noop, sx}, ref) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit();
  };

  return <Box ref={ref} sx={sx} component="form" onSubmit={handleSubmit}>{children}</Box>;
});

Form.displayName = 'Form';
export default Form;
